import Button, { ButtonHTMLTag, ButtonSize } from '@/app/components/Button/Button';
import { PropsWithChildren } from 'react';

type SubmitButtonProps = PropsWithChildren & {
  isSubmitting: boolean;
};

export const SubmitButton = ({ isSubmitting, children }: SubmitButtonProps) => {
  return (
    <Button
      className="w-full mb-[48px]"
      size={ButtonSize.XL}
      tagSpecificProps={{ type: 'submit', htmlTag: ButtonHTMLTag.BUTTON, disabled: isSubmitting }}
    >
      {children}
    </Button>
  );
};
